// **解析状态**:
// - `pending`: 初始状态
// - `parsing`: 解析中
// - `completed`: 解析完成
// - `failed`: 解析失败
export enum ParseStatus {
  PENDING = 'pending',
  PARSING = 'parsing',
  COMPLETED = 'completed',
  FAILED = 'failed',
}

export type FileType = 'PDF' | 'Word';

export interface ResumeDTO {
  resumeNumber: number;
  userId: number;
  fileUrl: string;
  fileName: string;
  fileType: FileType;
  fileSize: number;
  parseStatus: ParseStatus;
  parsedContent: string;
  resumeMetadata?: Partial<ResumeMetadata>;
  createdAt: string;
  updatedAt: string;
}

/**
 {
  "name": "林雨笑",
  "phone": "1589632000",
  "email": "hela215@163.com",
  "work_experience": [
    {
      "company": "华中师范大学经济管理学院学生会",
      "position": "副部长",
      "start_date": "2015-03",
      "end_date": "2017-06",
      "description": "参与组织协调学院各类学生活动，具备良好的公共关系意识和组织协调能力。"
    },
    {
      "company": "武汉思拓外语培训学校",
      "position": "英语口语教师",
      "start_date": "2013-02",
      "end_date": "2014-06",
      "description": "负责英语口语课程教学，提升学生语言表达与沟通能力。"
    },
    {
      "company": "广州科技大学组织部",
      "position": "宣传干事",
      "start_date": "2011-06",
      "end_date": "2012-12",
      "description": "负责校园活动宣传工作，策划并执行多项宣传活动。"
    },
    {
      "company": "广州科技大学网络宣传部",
      "position": "部长",
      "start_date": "2009-09",
      "end_date": "2011-02",
      "description": "领导团队完成校园网络宣传内容制作与发布，提升学校形象传播效果。"
    }
  ],
  "education": [
    {
      "school": "华中师范大学",
      "major": "国际经济与贸易",
      "degree": "硕士",
      "start_date": "2013-09",
      "end_date": "2017-06"
    },
    {
      "school": "广州科技大学",
      "major": "对外汉语",
      "degree": "学士",
      "start_date": "2009-09",
      "end_date": "2013-06"
    }
  ],
  "other_info": {
    "gender": "女",
    "native_place": "广州越秀",
    "political_status": "中共党员",
    "english_level": "四级",
    "computer_level": "二级",
    "current_residence": "武汉市洪山区",
    "awards": [
      "2011年 广州科技大学校级一等奖奖学金",
      "2012年 广州科技大学国家一等奖学金",
      "2015年 华中师范大学校园十大歌手一等奖",
      "2016年 湖北省创青春创业计划移动专项赛银奖",
      "2016年 武汉思拓外语学校“优秀骨干教师”称号",
      "2016年 大学生课外技术创新活动“优胜奖”"
    ],
    "certificates": [
      "全国计算机等级二级证书",
      "英语四级证书",
      "普通话水平测试二级甲等",
      "Adobe认证设计师资格证书",
      "机动车驾驶证",
      "全国信息技术应用培训教育工程职业技能证书（AutoCAD建筑设计）"
    ]
  },
  "skills": {
    "professional_skills": [
      "管理学",
      "行政管理",
      "企业运营管理",
      "供应链管理",
      "商务礼仪",
      "谈判技巧",
      "西方经济学",
      "会计学基础",
      "税法",
      "成本会计",
      "财务会计",
      "会计电算化",
      "特殊事项会计",
      "审计",
      "经济学",
      "税务学"
    ],
    "project_skills": [
      "活动策划",
      "组织协调",
      "宣传策划",
      "英语口语教学",
      "沟通能力",
      "时间管理",
      "学习能力",
      "责任心",
      "抗压能力",
      "创新思维"
    ]
  }
}
 */
export interface ResumeMetadata {
  name: string;
  phone: string;
  email: string;
  workExperience: Partial<WorkExperience>[];
  education: Partial<Education>[];
  otherInfo: Partial<OtherInfo>;
  skills: Partial<Skills>;
}

export interface WorkExperience {
  company: string; // 公司
  position: string; // 职位
  startDate: string; // 开始时间
  endDate: string; // 结束时间
  description: string; // 描述
}

export interface Education {
  school: string; // 学校
  major: string; // 专业
  degree: string; // 学位
  startDate: string; // 开始时间
  endDate: string; // 结束时间
}

export interface OtherInfo {
  gender: string; // 性别
  nativePlace: string; // 籍贯
  politicalStatus: string; // 政治面貌
  englishLevel: string; // 英语水平
  computerLevel: string; // 计算机水平
  currentResidence: string; // 现居地
  awards: string[]; // 奖项
  certificates: string[]; // 证书
}

export interface Skills {
  professionalSkills: string[]; // 专业技能
  projectSkills: string[]; // 项目技能
}
